import { DemoApiMock } from '../types'
import { getDemoData, matchRestRequest } from 'api/demo/utils'
import { PaginatedShiftTimeline, TimelineShift } from 'api/shift'

interface GetShiftsForTimelineRequest {
  startDate?: string | undefined
  headCursor?: string | undefined
  tailCursor?: string | undefined
  positionId?: number | undefined
  locationId?: number | undefined
}

export const mockShiftTimeline: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shifts_for_timeline_a024cfed',
      'POST'
    ),
  getResponse: async (request) => {
    const params = request.data as GetShiftsForTimelineRequest
    const startAt = params.startDate
    const headCursor = params.headCursor
    const tailCursor = params.tailCursor
    const positionId: number | undefined = params.positionId
    const locationId: number | undefined = params.locationId
    const demoData = getDemoData()
    const shifts = demoData.shifts.filter((shift) => {
      if (locationId && shift.location?.id !== locationId) {
        return false
      }
      if (positionId && shift.position?.id !== positionId) {
        return false
      }
      return true
    })

    let timelineData: PaginatedShiftTimeline | undefined
    if (startAt) {
      const startDate = new Date(startAt)
      const filteredShifts = shifts.filter((shift) => {
        return new Date(shift.startsAt!).getTime() >= startDate.getTime()
      })
      const headCursorShift = filteredShifts.length ? filteredShifts[0] : null
      timelineData = {
        items: filteredShifts as TimelineShift[],
        headCursor: headCursorShift
          ? `${headCursorShift.startsAt}|${headCursorShift.id}`
          : undefined,
        tailCursor: undefined,
      }
    } else if (headCursor) {
      const [startsAt, id] = headCursor.split('|')
      const startDate = new Date(startsAt)
      const filteredShifts = shifts.filter((shift) => {
        const shiftStartsAt = new Date(shift.startsAt!)
        if (shiftStartsAt < startDate) {
          return true
        }
        if (shiftStartsAt > startDate) {
          return false
        }
        return shift.id < Number(id)
      })
      const tailCursorShift = filteredShifts[filteredShifts.length - 1]
      timelineData = {
        items: filteredShifts as TimelineShift[],
        headCursor: undefined,
        tailCursor: tailCursorShift
          ? `${tailCursorShift.startsAt}|${tailCursorShift.id}`
          : undefined,
      }
    } else if (tailCursor) {
      const [startsAt, id] = tailCursor.split('|')
      const startDate = new Date(startsAt)
      const filteredShifts = shifts.filter((shift) => {
        const shiftStartsAt = new Date(shift.startsAt!)
        if (shiftStartsAt > startDate) {
          return true
        }
        if (shiftStartsAt < startDate) {
          return false
        }
        return shift.id > Number(id)
      })
      const headCursorShift = filteredShifts.length ? filteredShifts[0] : null
      timelineData = {
        items: filteredShifts as TimelineShift[],
        headCursor: headCursorShift
          ? `${headCursorShift.startsAt}|${headCursorShift.id}`
          : undefined,
        tailCursor: undefined,
      }
    }

    return {
      data: {
        company: {
          infiniteShifts: {
            ...timelineData,
            items: timelineData?.items,
          },
        },
      },
    }
  },
}
